import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { BASE_URL_USER } from "../../Redux/App/action";
import axios from "axios";
import { FaPencil } from "react-icons/fa6";

import EditDeliveryLocation from "../UI/EditDeliveryLocation";
import CustomButton from "../customButton/CustomButton";

const initialValues = {
  contactPersonName: "",
  contactNo: "",
  addressType: "",
  addressUnit: "",
  locality: "",
  landmark: "",
  city: "",
  state: "",
  pincode: "",
  default: false,
};

const addressSchema = Yup.object({
  contactPersonName: Yup.string().required("required").min(2).max(30),
  contactNo: Yup.string()
    .matches(/^[6-9][0-9]{9}$/, "Must be valid number")
    .required("required"),
  addressType: Yup.string().required("required"),
  addressUnit: Yup.string().required("required"),
  locality: Yup.string(),
  landmark: Yup.string(),
  city: Yup.string().required("required"),
  state: Yup.string().required("required"),
  pincode: Yup.string().required("required").min(6).max(6),
  default: Yup.string(),
});

const EditAddress = ({ addressId, getAddressData }) => {
  const accessToken = localStorage.getItem("token");
  const [addressData, setAddressData] = useState(initialValues);
  const [formDisable, setFormDisable] = useState(true);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const getUserAddressById = async (addressId) => {
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/addressId?addressId=${addressId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setAddressData({
          contactPersonName: response.data?.payload?.contactPersonName || "",
          contactNo: response.data?.payload?.contactNo || "",
          addressType: response.data?.payload?.addressType || "",
          addressUnit: response.data?.payload?.addressUnit || "",
          locality: response.data?.payload?.locality || "",
          landmark: response.data?.payload?.landmark || "",
          city: response.data?.payload?.city || "",
          state: response.data?.payload?.state || "",
          pincode: response.data?.payload?.pincode || "",
          default: response.data?.payload?.default || false,
        });
      }
    } catch (error) {
      toast({
        title: error.message,
        status: "error",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
    }
  };

  const handleUpdatedForm = async (formData, addressId) => {
    try {
      const res = await axios.post(
        `${BASE_URL_USER}/api/v1/user/update-address?addressId=${addressId}`,
        formData,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (res.status === 200) {
        getAddressData();
        onClose();
        toast({
          title: "Address Updated successfully",
          status: "success",
          duration: 2000,
          position: "top",
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: error.message,
        status: "error",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
    }
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: addressData,
    validationSchema: addressSchema,
    enableReinitialize: true,
    async onSubmit(values) {
      try {
        handleUpdatedForm(values, addressId);
        // await add(values);
      } catch (error) {
        toast({
          title: error.message,
          status: "error",
          duration: 2000,
          position: "top",
          isClosable: true,
        });
      }
    },
  });

  return (
    <div>
      <FaPencil
        className="cursor-pointer"
        onClick={() => {
          getUserAddressById(addressId);
          onOpen();
        }}
      />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <div className="mt-10 mb-3">
              <form onSubmit={handleSubmit}>
                <EditDeliveryLocation
                  values={values}
                  errors={errors}
                  touched={touched}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  addressData={addressData}
                  formDisable={formDisable}
                  setFormDisable={setFormDisable}
                />
                <div className="flex justify-end gap-3">
                  <CustomButton
                    className="!bg-[#c7c7c7] hover:!bg-[#d4d4d4]"
                    onClick={(e) => {
                      e.preventDefault();
                      onClose();
                    }}
                  >
                    Cancel
                  </CustomButton>

                  <CustomButton type="submit">Update</CustomButton>
                </div>
              </form>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default EditAddress;
